import Kiosk from 'components/Kiosk/Kiosk';
import KioskActivate from 'components/Kiosk/views/Activate';
import KioskIdle from 'components/Kiosk/views/Idle';
import KioskPhone from 'components/Kiosk/views/Phone';
import RegisterPatient from 'components/Kiosk/views/RegisterPatient';
import KioskScheduleAppointment from 'components/Kiosk/views/ScheduleAppointment';
import NotFound from 'components/NotFound';

import CHECK_IN from './checkin';

const KIOSK = [
  {
    path: 'kiosk',
    element: <Kiosk />,
    children: [
      { path: '', element: <KioskIdle /> },
      { path: 'idle', element: <KioskIdle /> },
      { path: 'phone', element: <KioskPhone /> },
      { path: 'activate', element: <KioskActivate /> },
      { path: 'register', element: <RegisterPatient /> },
      { path: 'schedule-appointment', element: <KioskScheduleAppointment /> },
      ...CHECK_IN,
      {
        path: '*',
        element: <NotFound portal="kiosk" />
      }
    ]
  }
];
export default KIOSK;
